import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-7" }
const _hoisted_2 = { class: "flex mb-4 space-x-3 latest_bookings-center" }
const _hoisted_3 = { class: "grid grid-cols-3 mb-6 gap-y-6 gap-x-4" }
const _hoisted_4 = { class: "px-4 py-6 border rounded-lg" }
const _hoisted_5 = { class: "text-[#23A2B4] text-3xl font-bold" }
const _hoisted_6 = { class: "px-4 py-6 border rounded-lg" }
const _hoisted_7 = { class: "text-[#23A2B4] text-3xl font-bold" }
const _hoisted_8 = { class: "px-4 py-6 border rounded-lg" }
const _hoisted_9 = { class: "text-[#23A2B4] text-3xl font-bold" }
const _hoisted_10 = { class: "w-full py-6 mt-5" }
const _hoisted_11 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_12 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_13 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_14 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_15 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_16 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "w-full py-6 mt-5" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import StatusPill from '@/components/StatusPill.vue';
import CalendarPicker from '@/components/CalendarPicker.vue';
import PagePagination from '@/components/PagePagination.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import ButtonComponent from "@/components/ButtonComponent.vue";

import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';

import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';
import Dashboard from "@/classes/Dashboard";
import { paginatePage } from '@/helpers/PageHelper';
import { format } from 'date-fns'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const router = useRouter();

// Data
const loader = ref(false);
const showError = ref(false);
const errorMsg = ref(null);

// Query
const filterDate = ref(null);
const filterCreatedDate = ref(null);
const goToPage   = ref();

// const booking_start_date = ref(null);
// const booking_end_date = ref(null);

// Page Renderer Data
const total_users = ref(0);
const new_users = ref(0);
const latest_bookings = ref([]);
const latest_bookings_count = ref(0);
const booking_calendar = ref([]);
const fully_booked_dates = ref([]);

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth();
const from = ref(null);
const to = ref(null);

const formatted_booking_calendar = ref([]);

// Methods
const fetchTotalUsers = () => {
    loader.value = true;

    const dateCreatedQuery = filterCreatedDate.value ? `&filterCreatedDate=${filterCreatedDate.value}` : '';

    Dashboard.fetchTotalUsers(`${dateCreatedQuery}`)
        .then((response: any) => {
            loader.value = false;
            total_users.value = response.data.total_users.response.total_patients;
            new_users.value = response.data.total_users.response.new_patients;

        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const fetchLatestBookings = (data: string) => {
    loader.value = true;

    const goToPageValue   = paginatePage(data);
    const dateQuery       = filterDate.value ? `&filterDate=${filterDate.value}` : '';
    const dateCreatedQuery = filterCreatedDate.value ? `&filterCreatedDate=${filterCreatedDate.value}` : '';

    Dashboard.fetchLatestBookings(`${goToPageValue}&${dateQuery}&${dateCreatedQuery}`)
        .then((response: any) => {
            loader.value = false;
            latest_bookings.value = response.data.latest_bookings;
            latest_bookings_count.value = response.data.total_bookings;

        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const fetchBookingCalendar = () => {
    loader.value = true;

    const payload = {
        booking_start_date: from.value,
        booking_end_date: to.value,
    }

    Dashboard.fetchBookingCalendar(payload)
        .then((response: any) => {
            loader.value = false;
            booking_calendar.value = response.data.booking_calendar.response;
            fully_booked_dates.value = response.data.fully_booked_dates

            formatBookingCalendar()
        })
        .catch((err) => {
            console.log(err);
            // loader.value = false;
            // showError.value = true;
            // errorMsg.value = err.response.data.message;
            
            // if(err.response.status == 401) {
            //     window.location.replace('/login');
            // }
        })
}

const formatBookingCalendar = () => {
    
    booking_calendar.value.forEach((booking:any) => {
        const marker:{
            date: string,
            type: string,
            tooltip: [{
                text: string
            }],
        } = {
            date: '',
            type: 'dot',
            tooltip: [{
                text: ''
            }], //[{ text: 'Dot with tooltip' }],
        }
        if(
            booking.confirmed_appointments_count > 0 ||
            booking.cancelled_appointments_count > 0 ||
            booking.completed_appointments_count > 0 
        ){     
            const options:any = { timeZone: 'Asia/Manila', year: 'numeric', month: '2-digit', day: '2-digit' };
            const convertedDate = new Date(booking.appointment_day).toLocaleDateString('en-US', options);
            const [month, day, year] = convertedDate.split('/');
            
            marker.date = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            marker.tooltip = [{
                text: `Confirmed: ${booking.confirmed_appointments_count} 
                    Cancelled: ${booking.cancelled_appointments_count}, 
                    Completed:${booking.completed_appointments_count}`
            }];
    
            formatted_booking_calendar.value.push(marker) 
        }
    });
}

const viewCalendarBookings = (date:string) => {
    date = format(new Date(date), 'yyyy-MM-dd')
    console.log(date);
    router.push(`/home/booking/${date}`)
}

const updateMonth = (val = null) => {
    // Get First and Last Day for Active Month
    const monthYear = {
        year: currentYear,
        month: currentMonth,
    }

    from.value = firstDayOfMonth(val ? val : monthYear)
    to.value = lastDayOfMonth(val ? val : monthYear);

    // Fetch Monthly Data
    fetchBookingCalendar();
}

const firstDayOfMonth = (val) => {
    const year = val.year;
    const month = val.month + 1;
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-01`;

    return formattedDate;
}

const lastDayOfMonth = (val) => {
    const year = val.year;
    const month = val.month + 1;
    const lastDay = new Date(year, month, 0).getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${lastDay.toString().padStart(2, '0')}`;

    return formattedDate;    
}

const applyFilter = () => {
    fetchTotalUsers();
    fetchLatestBookings(goToPage.value);
}

// Headers
const headers: { text: string }[] = [
    { text: 'ID' },
    { text: 'Patient/Company' },
    { text: 'Booking Type' },
    { text: 'Status' },
    { text: 'Booking Date' },
    { text: 'Date Created'}
];

const getStatusColor = (status: string) => {
    if(status) {
        let color = null;
        switch (status) {
            case 'Booked':
                color = 'blue';
                break;
        
            case 'Cancelled/No-Show':
            case 'Cancelled':
                color = 'red';
                break;
        
            case 'Done':
                color = 'green';
                break;
            
            default:
                color = 'yellow'
                break;
        }

        return color;
    }

    return 'yellow';
}

onMounted( () => {
    fetchTotalUsers();
    fetchLatestBookings(goToPage.value);
    updateMonth();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Dashboard" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DatePicker, {
            range: "",
            is24: "",
            isPresetRanges: "",
            modelValue: filterCreatedDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterCreatedDate).value = $event)),
            id: "create_date",
            name: "create_date",
            placeholder: "Created Start and End Date",
            label: "Created Start and End Date"
          }, null, 8, ["modelValue"]),
          _createVNode(DatePicker, {
            range: "",
            is24: "",
            isPresetRanges: "",
            modelValue: filterDate.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterDate).value = $event)),
            id: "booking_date",
            name: "booking_date",
            placeholder: "Booking Start and End Date",
            label: "Booking Start and End Date"
          }, null, 8, ["modelValue"]),
          _createVNode(ButtonComponent, {
            class: "mt-auto",
            type: "button",
            onClick: applyFilter
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Apply Filter ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("img", {
              class: "mb-4",
              src: "/assets/icons/nav/ic-people.svg",
              alt: ""
            }, null, -1)),
            _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mb-2 text-sm text-gray-500" }, "Total Users", -1)),
            _createElementVNode("p", _hoisted_5, _toDisplayString(total_users.value), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("img", {
              class: "mb-4",
              src: "/assets/icons/nav/ic-people.svg",
              alt: ""
            }, null, -1)),
            _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mb-2 text-sm text-gray-500" }, "New Users", -1)),
            _createElementVNode("p", _hoisted_7, _toDisplayString(new_users.value), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[9] || (_cache[9] = _createElementVNode("img", {
              class: "mb-4",
              src: "/assets/icons/nav/ic-note.svg",
              alt: ""
            }, null, -1)),
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mb-2 text-sm text-gray-500" }, "Bookings", -1)),
            _createElementVNode("p", _hoisted_9, _toDisplayString(latest_bookings_count.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "mb-2 text-lg text-gray-500" }, "Latest Bookings", -1)),
          _createVNode(DataTable, {
            headers: headers,
            count: latest_bookings_count.value
          }, {
            body: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(latest_bookings.value.data, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", _hoisted_12, [
                    (item.booking_type == 'Individual' || item.booking_type == 'Dependent')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(item.patient?.first_name) + " " + _toDisplayString(item.patient?.last_name), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(item.corporate_name ?? '--'), 1)
                        ], 64))
                  ]),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.booking_type ?? '--'), 1),
                  _createElementVNode("td", _hoisted_14, [
                    _createVNode(StatusPill, {
                      color: getStatusColor(item.status),
                      text: item.status
                    }, null, 8, ["color", "text"])
                  ]),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(new Date(item.booking_date).toISOString().split('T')[0]), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(new Date(item.booking_created_date).toISOString().split('T')[0]), 1),
                  _createElementVNode("td", _hoisted_17, [
                    (_ctx.$hasPermission('set-individual-patient-appointment-time') ||
                                        _ctx.$hasPermission('update-individual-patient-appointment-time') ||
                                        _ctx.$hasPermission('soft-book-dates-for-individual-patient') ||
                                        _ctx.$hasPermission('update-corporate-patient') ||
                                        _ctx.$hasPermission('update-participating-employees'))
                      ? (_openBlock(), _createBlock(ActionButton, {
                          key: 0,
                          "edit-btn": "",
                          onClick: ($event: any) => (_unref(router).push(`/branches/${item.branch.branch_id}/bookings/edit/${item.booking_type == 'Individual' || item.booking_type == 'Dependent' ? item.booking_id : item.booking_type == 'Corporate' ? item.corporate_booking_id : item.id}?patient_type=${item.booking_type == 'Individual' || item.booking_type == 'Dependent' || item.booking_type == 'Soft' ? item.booking_type : 'Corporate'}`))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["count"])
        ]),
        _createVNode(PagePagination, {
          class: "mb-6",
          items: latest_bookings.value,
          onNextPage: fetchLatestBookings
        }, null, 8, ["items"]),
        _createElementVNode("div", _hoisted_18, [
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "mb-2 text-lg text-gray-500" }, "Booking Calendar", -1)),
          _createVNode(CalendarPicker, {
            markers: formatted_booking_calendar.value,
            "fully-booked-dates": fully_booked_dates.value,
            "highlight-disabled-days": "",
            onUpdateMonth: updateMonth,
            onDateUpdate: viewCalendarBookings
          }, null, 8, ["markers", "fully-booked-dates"])
        ])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})